// extracted by mini-css-extract-plugin
export default {"avatar":"avatar__M3r3VemGGwxO","avatar-withImage":"avatar-withImage__FwIu9toqept6"};